import { get, put, post, destroy, download } from "./api";

const controller = 'TemplateFileProcess';

export const getWorkflows = async (tags, operand) => {
  let op = "";
  if (!!operand)
    op += `/${operand}`;
  return await get(`${controller}/workflow/${tags}${op}`);
}

export const getWorkflowAccess = async () => {
  return await get(`${controller}/workflow/access`);
}

export const getWorkflowEnvironments = async () => {
  return await get(`${controller}/workflow/environments`);
}

export const getSmartforms = async () => {
  return await get(`${controller}/smartform`);
}

export const getTextLibraryFolders = async () => {
  return await get(`${controller}/textlibrary/folders`);
}

export const validateTextLibraryFolders = async (folderIds) => {
  return await post(`${controller}/textlibrary/folders/validate`, folderIds);
}

export const getInteractTemplateFileProcessFromTemplateAndFileId = async (templateId, fileId) => {
  return await get(`${controller}/${templateId}/${fileId}`);
}

export const getProcessesLastDateFromEnvironmentGroupId = async (envgrpId) => {
  return await get(`${controller}/dates/envgrp/${envgrpId}`);
}

export const createInteractTemplateFileProcess = async (model) => {
  return await post(`${controller}`, model);
}

export const updateInteractTemplateFileProcess = async (id, model) => {
  return await put(`${controller}/${id}`, model);
}

export const deleteInteractTemplateFileProcess = async (id) => {
  return await destroy(`${controller}/${id}`);
}

// A 403 or 404 from these calls is answered on the page. The default is a full-page redirect, which would drop
// a review that took a while to read.
const answerInPage = { statusCodeHandlers: [403, 404].map(statusCode => ({ statusCode, handler: () => { } })) };

// Without file names the export holds every logic file. A choice is posted: a long list of names does not fit in a URL.
export const exportConnections = async (templateEnvironmentId, filename, fileNames = null) => {
  const options = fileNames ? { ...answerInPage, axiosParams: { method: 'post', data: { fileNames } } } : answerInPage;
  return await download(`${controller}/export/${templateEnvironmentId}`, filename, undefined, options);
}

export const previewConnectionImport = async (templateEnvironmentId, document) => {
  return await post(`${controller}/import/${templateEnvironmentId}/preview`, document, answerInPage);
}

export const importConnections = async (templateEnvironmentId, document, planHash, removeUnconnected = true) => {
  return await post(`${controller}/import/${templateEnvironmentId}`, { document, planHash, removeUnconnected }, answerInPage);
}

export const previewStaleSettingsCleanup = async (sourceTemplateEnvironmentId, targetTemplateEnvironmentId, fileName) => {
  return await post(`${controller}/cleanup-stale`, {
    sourceTemplateEnvironmentId,
    targetTemplateEnvironmentId,
    fileName,
    dryRun: true
  });
}

export const cleanupStaleSettings = async (sourceTemplateEnvironmentId, targetTemplateEnvironmentId, fileName) => {
  return await post(`${controller}/cleanup-stale`, {
    sourceTemplateEnvironmentId,
    targetTemplateEnvironmentId,
    fileName,
    dryRun: false,
    confirm: `cleanup ${fileName}`
  });
}
